<template>
<div class="chapter">
<div class="inner_page">
<div class="page-background-image"><img alt="image" src="images/page002.jpg"/></div>
<div class="page002text1">Text copyright © 2008 by Sylvia A. Rouss<br/>Illustrations copyright © 2008 by Katherine Janus Kahn</div>
<div class="page002text2">All rights reserved. International copyright secured. No part of this book may be<br/>reproduced, stored in a retrieval system, or transmitted in any form or by any means—<br/>electronic, mechanical, photocopying, recording, or otherwise—without the written<br/>permission of Lerner Publishing Group, Inc., except for the inclusion of brief quotes in an<br/>acknowledged review.</div>
<div class="page002text3">KAR-BEN PUBLISHING<br/>A division of Lerner Publishing Group, Inc.<br/>241 First Avenue North<br/>Minneapolis, MN 55401 U.S.A.<br/>1-800-4-Karben</div>
<div class="page002text4">Website address: <a href="http://www.karben.com" target="_blank">www.karben.com</a></div>
<div class="page002text5">Library of Congress Cataloging-in-Publication Data</div>
<div class="page002text6">Rouss, Sylvia A.<br/><span class="cpadd">Sammy Spider’s first Shavuot / by Sylvia A. Rouss ; illustrated by Katherine<br/>Janus Kahn.<br/><span class="cpadd1"><span class="ws20">p. cm.</span><br/><span class="cpadd">Summary: Sammy Spider lowers himself down on a strand of webbing to get a<br/>closer look at the Shapiro family’s preparations for Shavuot, a holiday celebrating<br/>the time when God gave the Torah to Moses. Includes a recipe for making blintzes.<br/><span class="cpadd">ISBN: 978–0–8225–7224–4 (lib. bdg. : alk. paper)<br/><span class="cpadd"><span class="ws2">[1. Shavuot—Fiction. 2. Spiders—Fiction.] I. Kahn, Katherine, ill. II. Title.</span><br/>PZ7.R7622Saq 2008<br/>[E]—dc22</span></span></span></span></span></div>
<div class="page002text7">2006039739</div>
<div class="page002text8">Manufactured in the United States of America<br/>2 – MG – 10/1/12</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page002.vue?85fe7716